import i18n from '@/locales'
import commonApi from '@/api/api.common'
export default [
  // {
  //   type: 'select',
  //   placeholder: '推送类型',
  //   filed: 'type',
  //   default: '',
  //   options: [
  //     {
  //       code: '广告',
  //       name: '广告'
  //     },
  //     {
  //       code: '通知',
  //       name: '通知'
  //     },
  //     {
  //       code: '服务',
  //       name: '服务'
  //     }
  //   ]
  // },
  {
    type: 'datepicker',
    placeholder: '',
    default: [],
    filed: 'daterange',
    params: {
      start: 'startTime',
      end: 'endTime'
    }
  },
  {
    type: 'select',
    placeholder: i18n.t('Message.pushUser'),
    filed: 'pushUser',
    default: '',
    query: commonApi.app_user_type_select
  }
]
